<template>
  <Modal
    no-cancel
    :tracking="{ action: trackingAction, topicKey: 'compliance-error' }"
    @confirm="onConfirm"
  >
    <template #headline>
      {{ $t(`${error}.modal.headline`) }}
    </template>
    <i18n-t :keypath="`${error}.modal.message`" scope="global" tag="p">
      <template v-if="showFaq" #faq>
        <a
          class="text-link"
          href="https://support.lotto.com/hc/en-us/sections/360011202734-Enabling-Location-Services"
          target="_blank"
        >
          {{ $t('common.words.enablinglocationservices') }}
        </a>
      </template>
      <template #contactSupport>
        <a class="text-link" :href="$localePath('/service?chat=true')">
          {{ $t('common.sentences.contactsupport').toLowerCase() }}
        </a>
      </template>
    </i18n-t>

    <template #confirm>
      {{ $t(`${error}.modal.confirm`) }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import type { TrackingImpressionProps } from '#tracking/app/types/tracking'

import { ComplianceError } from '~/composables/compliance'

type ComplianceErrorModalEmits = {
  (e: 'confirm'): void
}

type ComplianceErrorModalProps = {
  error: Maybe<ComplianceError>
  navigateBack?: boolean
  trackingAction: TrackingImpressionProps['tracking']['action']
}
const { resetError } = useCompliance()
const { navigateBack: back, navigateToLocalized } = useRouterUtils()
const route = useRoute()

const emit = defineEmits<ComplianceErrorModalEmits>()

const { error, navigateBack = true } = defineProps<ComplianceErrorModalProps>()

const showFaq = computed(
  () =>
    error &&
    [
      ComplianceError.DeviceProfilingDeniedPermissions,
      ComplianceError.GeoCheckDeniedPermissions,
      ComplianceError.GeoCheckGeneral,
    ].includes(error),
)

const onConfirm = async () => {
  emit('confirm')

  if (navigateBack) {
    if (route.query?.backroute && typeof route.query.backroute === 'string') {
      await navigateToLocalized({ path: route.query.backroute }, { replace: true })
    } else {
      await back()
    }
  }

  resetError()
}
</script>
